import { FC } from 'react';
import ExploreGptHandler from '../Components/ExploreGpt/ExploreGptHandler';

export const PageExploreGpts: FC = () => {
    return <ExploreGptHandler />;
};
